/** Fixed social barks - no free-text chat. */

export const BARK_IDS = [
  "woof",
  "arf",
  "yap",
  "awoo",
  "whine",
  "wag",
  "happy",
  "sniff",
] as const;

export type BarkId = (typeof BARK_IDS)[number];

export interface BarkDef {
  id: BarkId;
  /** Short button label. */
  label: string;
  /** Bubble / log text (allowlisted only). */
  text: string;
}

export const BARKS: Record<BarkId, BarkDef> = {
  woof: { id: "woof", label: "Woof", text: "Woof!" },
  arf: { id: "arf", label: "Arf", text: "Arf!" },
  yap: { id: "yap", label: "Yap", text: "Yap!" },
  awoo: { id: "awoo", label: "Awoo", text: "Awoo!" },
  whine: { id: "whine", label: "Whine", text: "*whines*" },
  wag: { id: "wag", label: "Wag", text: "*wags*" },
  happy: { id: "happy", label: "Happy", text: "*happy bark*" },
  sniff: { id: "sniff", label: "Sniff", text: "*sniff sniff*" },
};

export function barkById(id: string): BarkDef | undefined {
  return (BARKS as Record<string, BarkDef>)[id];
}

export const BARK_COOLDOWN_MS = 1200;
